export default "/yt-usdc.9411241972dbda1e5c7b7519f5714474.svg";